import { render, staticRenderFns } from "./ListaAreaEmbargadaSemaMt.vue?vue&type=template&id=e022b176&lang=pug"
import script from "./ListaAreaEmbargadaSemaMt.vue?vue&type=script&lang=js"
export * from "./ListaAreaEmbargadaSemaMt.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports